import { useContext } from 'react'
import { Table, Modal, ModalFooter, Button } from 'react-bootstrap'
import { TableCell } from 'components/shared/widget'
import { Flex } from 'components/shared/flex'
import { Freezer } from 'entities/freezer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useState } from 'react'
import { ALPHABET } from 'utils/util'
import styled from 'styled-components'
import { Rack } from 'entities/rack'
import { RackVisualizer } from 'components/rack/rack_visualizer'
import { RackViewModel } from 'view_models/rack_view_model'

type FreezerVisualizerProps = {
    freezer?: Freezer
    onDisposeRack?: () => void
}

const FreezerVisualizer = ({ freezer, onDisposeRack }: FreezerVisualizerProps) => {
    const globalState = useContext(GlobalStateContext)
    const [showRack, setShowRack] = useState<boolean>(false)
    const [selectRack, setSelectRack] = useState<Rack>({})

    if (!freezer) {
        return <></>
    }

    const HighlightTableCell = styled.td`
        cursor: pointer;
        &:hover {
            background-color: #ddd;
        }
    `

    return (
        <>
            <Modal show={showRack} onHide={() => setShowRack(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{selectRack.locationCode}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Flex justifyContent="center">
                        <RackVisualizer rackId={selectRack.id} isPcrRack={selectRack?.rackType?.name === '7x7'} onDispose={onDisposeRack} />
                    </Flex>
                </Modal.Body>
                <ModalFooter>
                    <Button variant="secondary" onClick={() => setShowRack(false)}>
                        閉じる
                    </Button>
                </ModalFooter>
            </Modal>
            <Table>
                <tbody>
                    {new Array(freezer.rowSize).fill(0).map((_, freezerRow) => {
                        freezerRow += 1
                        return (
                            <tr key={'freezer-row-' + freezerRow}>
                                {new Array(freezer.colSize).fill(0).map((_, freezerCol) => {
                                    freezerCol += 1
                                    const sus = freezer.freezerSusSet?.find((sus) => sus.colNumber === freezerCol && sus.rowNumber === freezerRow)
                                    if (sus === undefined) return <></>
                                    return (
                                        <td key={'freezer-col-' + freezerCol}>
                                            <Table style={{ verticalAlign: 'middle', textAlign: 'center', background: 'white' }}>
                                                <thead>
                                                    <tr>
                                                        <TableCell th width={40} style={{ fontSize: 16 }}>
                                                            {sus?.locationCode?.replace(`${freezer.name}-`, '')}
                                                        </TableCell>
                                                        {new Array(sus?.colSize).fill(0).map((_, susCol) => {
                                                            return (
                                                                <TableCell th align="center" key={'sus-head-col-' + susCol}>
                                                                    {susCol + 1}
                                                                </TableCell>
                                                            )
                                                        })}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {new Array(sus?.rowSize).fill(0).map((_, susRow) => {
                                                        susRow += 1
                                                        return (
                                                            <tr key={'sus-row-' + susRow}>
                                                                <td>{ALPHABET[susRow - 1].toLowerCase()}</td>
                                                                {new Array(sus?.colSize).fill(0).map((_, susCol) => {
                                                                    susCol += 1
                                                                    const rack = sus?.rackSet?.find(
                                                                        (rack) => rack.colNumber === susCol && rack.rowNumber === susRow
                                                                    )
                                                                    if (rack === undefined)
                                                                        return <HighlightTableCell key={'sus-col-' + susCol}></HighlightTableCell>

                                                                    const vm = new RackViewModel(rack)
                                                                    return (
                                                                        <HighlightTableCell
                                                                            key={'sus-col-' + susCol}
                                                                            onClick={() => {
                                                                                setSelectRack(rack!)
                                                                                setShowRack(true)
                                                                            }}
                                                                        >
                                                                            <Flex flexDirection="column" alignItems="center">
                                                                                {rack?.locationCode}
                                                                                {vm.progressView()}
                                                                                {vm.expireDateView()}
                                                                            </Flex>
                                                                        </HighlightTableCell>
                                                                    )
                                                                })}
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </>
    )
}

export default FreezerVisualizer
